// eslint-disable-next-line @typescript-eslint/no-explicit-any
function decimalAdjust(type: 'round' | 'floor' | 'ceil', rawValue: any, rawExp: number) {
  let value = rawValue;
  let exp = rawExp;

  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  if (Number.isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }

  const decimalPlaces = Math.abs(exp);
  const multiplier = Math.pow(10, decimalPlaces);

  if (exp > 0) {
    return Math[type](value / multiplier) * multiplier;
  }

  return Math[type](value * multiplier) / multiplier;
}

export function roundNumber(value: number | string, exp: number) {
  return decimalAdjust('round', value, exp);
}

export function roundToNearestDecimal(value: number, decimal = 1) {
  return +value.toFixed(decimal);
}
